import React, { FC } from 'react';

import { BUTTON_TYPES, EvBodyMedium, TITLE_MODES } from '@evinced-private/ui-common';

import { PlatformPopup } from 'src/common/components/platform-popup/PlatformPopup';

import { CONFIRM_LABEL_BY_ENTITY, TITLE_BY_ENTITY } from './DeleteConfirmationDialog.constants';
import { DELETE_CONFIRMATION_DIALOG_LABELS } from './DeleteConfirmationDialog.labels';
import { IDeleteConfirmationDialogProps } from './DeleteConfirmationDialog.types';

export const DeleteConfirmationDialog: FC<IDeleteConfirmationDialogProps> = ({
	isOpen,
	onConfirm,
	onCancel,
	isDeleting = false,
	entityName = 'session',
	isCentered,
	isBgTransparent
}) => {
	if (!isOpen) {
		return null;
	}

	return (
		<PlatformPopup
			isControlled
			isOpen
			title={TITLE_BY_ENTITY[entityName]}
			titleMode={TITLE_MODES.MAIN}
			onClose={onCancel}
			isPopupLoading={isDeleting}
			isCentered={isCentered}
			isBgTransparent={isBgTransparent}
			buttons={[
				{
					onClick: onCancel,
					title: DELETE_CONFIRMATION_DIALOG_LABELS.CANCEL,
					type: BUTTON_TYPES.SECONDARY
				},
				{
					onClick: onConfirm,
					title: CONFIRM_LABEL_BY_ENTITY[entityName],
					type: BUTTON_TYPES.PRIMARY,
					disabled: isDeleting
				}
			]}
		>
			<EvBodyMedium>{DELETE_CONFIRMATION_DIALOG_LABELS.BODY}</EvBodyMedium>
		</PlatformPopup>
	);
};
